import * as React from "react";
const IconAmbulanceAlt1 = (props) => (
  <svg className={"fill-current"}
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    viewBox="0 0 64 64"
    width={props.size || "48"}
    height={props.size || "48"}
    {...props}
  >
    <path d="M57.8 13.3H33V9.8c0-.6-.4-1-1-1s-1 .4-1 1v3.5h-7.3c-6 0-11.6 2.7-15.3 7.5l-5.5 7c-.6.7-.9 1.7-.9 2.6v10.4C2 43.1 3.9 45 6.2 45h4.3c-.6 1-.9 2.2-.9 3.4 0 3.8 3.1 6.8 6.8 6.8 3.8 0 6.8-3.1 6.8-6.8 0-1.2-.3-2.4-.9-3.4H42c-.6 1-.9 2.2-.9 3.4 0 3.8 3.1 6.8 6.8 6.8s6.8-3.1 6.8-6.8c0-1.2-.3-2.4-.9-3.4h4c2.3 0 4.2-1.9 4.2-4.2V17.5c0-2.3-1.9-4.2-4.2-4.2M10 22c3-3.8 7.3-6.1 12-6.6 0 .1-.1.2-.1.3v12.6H5.1zm6.4 31.2c-2.7 0-4.8-2.2-4.8-4.8s2.2-4.8 4.8-4.8 4.8 2.2 4.8 4.8-2.1 4.8-4.8 4.8m31.5 0c-2.7 0-4.8-2.2-4.8-4.8s2.2-4.8 4.8-4.8 4.8 2.2 4.8 4.8-2.1 4.8-4.8 4.8M60 40.8c0 1.2-1 2.2-2.2 2.2h-5.7c-1.2-.9-2.6-1.4-4.2-1.4s-3 .5-4.2 1.4H20.6c-1.2-.9-2.6-1.4-4.2-1.4s-3 .5-4.2 1.4h-6C5 43 4 42 4 40.8V30.3h18.9c.6 0 1-.4 1-1V15.7c0-.1 0-.3-.1-.4h34c1.2 0 2.2 1 2.2 2.2z" />
    <path d="M48.5 28.2h-4.7v-4.7c0-.6-.4-1-1-1s-1 .4-1 1v4.7h-4.7c-.6 0-1 .4-1 1s.4 1 1 1h4.7v4.7c0 .6.4 1 1 1s1-.4 1-1v-4.7h4.7c.6 0 1-.4 1-1s-.4-1-1-1" />
  </svg>
);
export default IconAmbulanceAlt1;
